<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button id="confirm-btn-loading" size="small" :textButton="$t('Shipped')"
        :iconStyle="{LeftIconName: 'TruckIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" @click="requestPickup()" class="vs-con-loading__container w-full"/>
    </template>
    <template v-else-if="selected.length !== 0 && selected.filter((item) => item.status === 'ready_to_ship').length !== selected.length && selected.length !== 0">
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select only orders that are ready to ship!')}`">
        <shipblu-button size="small" :textButton="$t('Shipped')"
        :iconStyle="{LeftIconName: 'TruckIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to mark as shipped!')}`">
        <shipblu-button size="small" :textButton="$t('Shipped')"
        :iconStyle="{LeftIconName: 'TruckIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import { sendFulfillmentRequest } from '../../../../http/axios/requestHelper.js'
export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0 && val.filter(item => item.status === 'ready_to_ship').length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    requestPickup () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#confirm-btn-loading',
        scale: 0.45
      })
      const trackings = []
      let url = ''
      this.selected.forEach(element => {
        if (element.status === 'ready_to_ship') {
          url = `api/v1/fc/orders/${this.selected[0].id}/tracking/`
          trackings.push({
            order:element.id,
            status: 'shipped'
          })
        }
      })
      sendFulfillmentRequest(true, false, this, url, 'post', trackings, true,
        () => {
          this.$emit('loadShipments')
          this.$emit('selected', [])
          this.$vs.loading.close('#confirm-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>